/* eslint-disable @typescript-eslint/no-useless-constructor */
import { SupabaseClient } from '@supabase/supabase-js';
import { BaseRepository } from '../BaseRepository';
import { TABLE_NAMES } from '../types';

/**
 * Cache repository that handles all cache-related database operations
 * For homework analytics caching operations
 */
export class CacheRepository extends BaseRepository {
  constructor(supabase: SupabaseClient<any, 'public', any>) {
    super(supabase);
  }

  /**
   * Get all cached homework data by article ID
   */
  async getCachedHomeworksByArticleId(): Promise<{ data: any[] }> {
    try {
      const { data } = await this.supabase
        .from(TABLE_NAMES.HOMEWORK_ARTICLE_CACHE)
        .select('*');
      return { data: data || [] };
    } catch (error) {
      return { data: [] };
    }
  }

  /**
   * Cache homework data for an article
   */
  async cacheHomeworkByArticleId(
    articleId: string,
    cacheData: any,
  ): Promise<void> {
    try {
      await this.supabase.from(TABLE_NAMES.HOMEWORK_ARTICLE_CACHE).upsert({
        article_token: articleId,
        data: cacheData,
        created_at: new Date(),
      });
    } catch (error) {
      console.error('Error caching homework by article ID:', error);
    }
  }

  /**
   * Get all cached homework data by student ID
   */
  async getCachedHomeworksByStudentId(): Promise<{ data: any[] }> {
    try {
      const { data } = await this.supabase
        .from(TABLE_NAMES.HOMEWORK_STUDENT_CACHE)
        .select('*');
      return { data: data || [] };
    } catch (error) {
      return { data: [] };
    }
  }

  /**
   * Cache homework data for a student
   */
  async cacheHomeworkByStudentId(
    studentId: string,
    cacheData: any,
  ): Promise<void> {
    try {
      await this.supabase.from(TABLE_NAMES.HOMEWORK_STUDENT_CACHE).upsert({
        student_token: studentId,
        data: cacheData,
        created_at: new Date(),
      });
    } catch (error) {
      console.error('Error caching homework by student ID:', error);
    }
  }

  /**
   * Get all cached homework data by class ID
   */
  async getCachedHomeworksByClassId(): Promise<{ data: any[] }> {
    try {
      const { data } = await this.supabase
        .from(TABLE_NAMES.HOMEWORK_CLASS_CACHE)
        .select('*');
      return { data: data || [] };
    } catch (error) {
      return { data: [] };
    }
  }

  /**
   * Cache homework data for a class
   */
  async cacheHomeworkByClassId(classId: string, cacheData: any): Promise<void> {
    try {
      await this.supabase.from(TABLE_NAMES.HOMEWORK_CLASS_CACHE).upsert({
        class_token: classId,
        data: cacheData,
        created_at: new Date(),
      });
    } catch (error) {
      console.error('Error caching homework by class ID:', error);
    }
  }
}
